import { lazy } from "react";

/**
 * Pages « Déménagement Paris Xe arrondissement » — basées sur ArrondissementPageLayout.
 */
const DemenagementParis1er = lazy(() => import("@/pages/DemenagementParis1er"));
const DemenagementParis2e = lazy(() => import("@/pages/DemenagementParis2e"));
const DemenagementParis3e = lazy(() => import("@/pages/DemenagementParis3e"));
const DemenagementParis4e = lazy(() => import("@/pages/DemenagementParis4e"));
const DemenagementParis5e = lazy(() => import("@/pages/DemenagementParis5e"));
const DemenagementParis6e = lazy(() => import("@/pages/DemenagementParis6e"));
const DemenagementParis7e = lazy(() => import("@/pages/DemenagementParis7e"));
const DemenagementParis8e = lazy(() => import("@/pages/DemenagementParis8e"));
const DemenagementParis9e = lazy(() => import("@/pages/DemenagementParis9e"));
const DemenagementParis10e = lazy(() => import("@/pages/DemenagementParis10e"));
const DemenagementParis11e = lazy(() => import("@/pages/DemenagementParis11e"));
const DemenagementParis12e = lazy(() => import("@/pages/DemenagementParis12e"));
const DemenagementParis13e = lazy(() => import("@/pages/DemenagementParis13e"));
const DemenagementParis14e = lazy(() => import("@/pages/DemenagementParis14e"));
const DemenagementParis15e = lazy(() => import("@/pages/DemenagementParis15e"));
const DemenagementParis16e = lazy(() => import("@/pages/DemenagementParis16e"));
const DemenagementParis17e = lazy(() => import("@/pages/DemenagementParis17e"));
const DemenagementParis18e = lazy(() => import("@/pages/DemenagementParis18e"));
const DemenagementParis19e = lazy(() => import("@/pages/DemenagementParis19e"));
const DemenagementParis20e = lazy(() => import("@/pages/DemenagementParis20e"));

export const ARRONDISSEMENT_ROUTES = [
  { path: "/demenagement-paris-1er", Component: DemenagementParis1er },
  { path: "/demenagement-paris-2e-arrondissement", Component: DemenagementParis2e },
  { path: "/demenagement-paris-3e-arrondissement", Component: DemenagementParis3e },
  { path: "/demenagement-paris-4e-arrondissement", Component: DemenagementParis4e },
  { path: "/demenagement-paris-5e-arrondissement", Component: DemenagementParis5e },
  { path: "/demenagement-paris-6e-arrondissement", Component: DemenagementParis6e },
  { path: "/demenagement-paris-7e-arrondissement", Component: DemenagementParis7e },
  { path: "/demenagement-paris-8e-arrondissement", Component: DemenagementParis8e },
  { path: "/demenagement-paris-9e-arrondissement", Component: DemenagementParis9e },
  { path: "/demenagement-paris-10e-arrondissement", Component: DemenagementParis10e },
  { path: "/demenagement-paris-11e-arrondissement", Component: DemenagementParis11e },
  { path: "/demenagement-paris-12e-arrondissement", Component: DemenagementParis12e },
  { path: "/demenagement-paris-13e-arrondissement", Component: DemenagementParis13e },
  { path: "/demenagement-paris-14e-arrondissement", Component: DemenagementParis14e },
  { path: "/demenagement-paris-15e-arrondissement", Component: DemenagementParis15e },
  { path: "/demenagement-paris-16e-arrondissement", Component: DemenagementParis16e },
  { path: "/demenagement-paris-17e-arrondissement", Component: DemenagementParis17e },
  { path: "/demenagement-paris-18e-arrondissement", Component: DemenagementParis18e },
  { path: "/demenagement-paris-19e-arrondissement", Component: DemenagementParis19e },
  { path: "/demenagement-paris-20e-arrondissement", Component: DemenagementParis20e },
];
